import type { CSSProperties } from 'react';

import {
  type IndexedPopupButton,
  POPUP_POSITION,
  type PopupCardContent,
  type PopupPosition,
} from './types';

export function getOverlayStyles(
  position: PopupPosition,
  overlayOpacity?: number,
): CSSProperties {
  if (position === POPUP_POSITION.CENTER_MODAL) {
    return {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: `rgba(0, 0, 0, ${overlayOpacity ?? 0.5})`,
      zIndex: 10000,
    };
  }
  return {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 10000,
  };
}

/**
 * 캠페인 버튼 URL 은 서버/관리자 설정값이라 신뢰 경계 밖이다. `javascript:`/`data:`
 * 같은 비-http scheme 이 그대로 window.open 에 들어가지 않도록, http(s) 및 상대 경로만
 * 허용한 canonical URL 을 돌려준다(허용 안 되면 null). 모든 카드 분기가 공유한다
 * (CenterModal 이 자체 window.open 으로 우회하지 않도록 SSOT 로 둔다).
 */
export function toSafeOpenUrl(rawUrl: string): string | null {
  const base =
    typeof window !== 'undefined' ? window.location.origin : undefined;
  try {
    const parsed = new URL(rawUrl, base);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.href;
    }
    return null;
  } catch {
    return null;
  }
}

export function reverseWithOriginalIndex(
  buttons: PopupCardContent['buttons'],
): IndexedPopupButton[] {
  return buttons
    .map((button, originalIndex) => ({
      ...button,
      originalIndex,
    }))
    .reverse();
}
